var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 27,
    viewBox: "0 0 50 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96019 11.7747H34.4637L31.5022 3.33447L47.9378 12.8115L32.0941 26.1379L35.2039 17.9937L1.14697 21.3994L8.6987 16.2172L3.96019 11.7747Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96021 9.96558C6.50188 9.90308 9.04412 9.82696 11.5858 9.78606L19.2114 9.64063L26.837 9.50769L34.4625 9.40259L33.9314 10.1513L30.8483 1.75429L30.2041 0L31.8465 0.926003L40.1094 5.58668C42.8653 7.13759 45.6092 8.70838 48.352 10.2826L49.3791 10.8723L48.4718 11.6375L40.5594 18.3121L32.6191 24.9531L30.1717 27L31.3306 24.0374L34.5069 15.9187L35.2766 16.9254L18.232 18.4677L9.70539 19.1966L1.1754 19.8903L0 19.9857L0.974289 19.3409L8.61464 14.2877L8.5976 14.5132L3.96021 9.96558ZM3.96021 9.96558L8.79757 14.3019L8.92994 14.4206L8.77996 14.5274L1.31685 19.8391L1.11631 19.2903L9.61449 18.2814L18.1161 17.3071L35.1284 15.4437L36.3219 15.3131L35.8981 16.451L32.8554 24.6202L31.5675 23.7045L39.4709 17.0191L47.4021 10.3672L47.522 11.7221C44.7855 10.1371 42.0512 8.54931 39.3283 6.94159L31.1551 2.12525L32.1532 1.29697L34.9931 9.77981L35.2477 10.5394L34.4625 10.5286L26.837 10.4235L19.2114 10.2905L11.5858 10.1451C9.04412 10.1042 6.50245 10.0281 3.96021 9.96558Z",
    fill: "#312734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrwo);
export default __webpack_public_path__ + "static/media/arrwo.75b5684a935d489b5bb8cb6936e6878c.svg";
export { ForwardRef as ReactComponent };